import { Link } from 'react-router-dom';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1>About PickSix Pro</h1>
        <p className="about-subtitle">
          Whether you're a coach, a player, or you just love the game, PickSix Pro is for you.
        </p>
      </section>

      <section className="about-content">
        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            PickSix Pro was created to help coaches, players, and football fans better understand 
            the complexities of defensive coverages. Our interactive simulator brings plays to life, 
            making it easier to learn and teach defensive concepts.
          </p>
        </div>

        <div className="about-section">
          <h2>What We Offer</h2>
          <p>
            Our platform provides real-time visualization of various coverage schemes including 
            man-to-man, zone, and match coverages. Watch how defenders react to different offensive 
            routes and gain insights into the chess match between offense and defense.
          </p>
        </div>

        <div className="about-section">
          <h2>Get In Touch</h2>
          <p>
            Have questions or feedback? We'd love to hear from you. Reach out to our team 
            and let us know how we can improve your experience.
          </p>
          <Link to="/contact" className="contact-link-button">
            Contact Us
          </Link>
        </div>
      </section>

      <section className="about-cta">
        <h2>Ready to Start?</h2>
        <p>Jump into the simulator and explore defensive coverages.</p>
        <Link to="/simulator" className="cta-button">
          Launch Simulator
        </Link>
      </section>
    </div>
  );
}

export default AboutPage;
